export default [
  [`Размер`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [
    `Российский размер`,
    `42-44`,
    `44-46`,
    `48-50`,
    `50-52`,
    `52-54`,
    `54-56`,
    `58-60`
  ],
  [`Обхват бёдер, см`, `92`, `96`, `100`, `104`, `108`, `112`, `114`],
  [
    `Рост, см`,
    `176-182`,
    `176-182`,
    `176-182`,
    `176-182`,
    `176-182`,
    `176-182`,
    `176-182`
  ]
];
